import { InMemoryCache } from "@apollo/client/cache";

export const cache = new InMemoryCache({});
